import React from 'react';
import './styles/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './components/navbar';
import Home from './pages/home';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Services from './pages/services';
import Institues from './pages/institutes';
import Courses from './pages/courses';

// Animated Routes wrapper component
function AnimatedRoutes() {
  const location = useLocation();
  
  // Luxury page transition variants
  const pageVariants = {
    initial: {
      opacity: 0,
      y: 60,
      scale: 0.95,
      filter: 'blur(10px)'
    },
    in: {
      opacity: 1,
      y: 0,
      scale: 1,
      filter: 'blur(0px)',
      transition: {
        duration: 0.8,
        ease: [0.25, 0.46, 0.45, 0.94], // Custom cubic-bezier for luxury feel
        staggerChildren: 0.1
      }
    },
    out: {
      opacity: 0,
      y: -60,
      scale: 1.05,
      filter: 'blur(10px)',
      transition: {
        duration: 0.6,
        ease: [0.55, 0.085, 0.68, 0.53]
      }
    }
  };

  return (
    <AnimatePresence mode="wait" initial={true}>
      <motion.div
        key={location.pathname}
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        style={{
          width: '100%',
          willChange: 'transform, opacity, filter'
        }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path='/services' element={<Services/>}/>
          <Route path='/institutes' element={<Institues/>}/>
          <Route path='/courses' element={<Courses/>}/>
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  return (
    <main>
      <Router>
        <Navbar />
        <div style={{ 
          position: 'relative', 
          minHeight: '100vh'
        }}>
          <AnimatedRoutes />
        </div>
      </Router>
    </main>
  );
}

export default App;